export default {
  min: {
    title:
      'Entrega en tu ubicación: Importe necesario para alcanzar el pedido mínimo (Subtotal excl. gastos de envío y propina)',
    description:
      'Lo sentimos, aún no puedes pedir. {{name}} ha establecido un importe mínimo de pedido de {{threshold}} (excl. gastos de envío)',
  },
  max: {
    title: 'Valor máximo de pedido para entrega alcanzado (Total excl. gastos de envío)',
    description:
      'Tu pedido ha alcanzado el valor máximo permitido de {{threshold}} para entrega online. Para pedidos que superen este importe, contáctanos directamente para que podamos organizar la entrega. ¡Gracias por tu comprensión!',
  },
};
